/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Content Explorer
 *| (C) Copyright IBM Corp. 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../lib/@waca/dashboard-common/dist/utils/ContentUtil',
	'underscore'
], (ContentUtil, _) => {
	/**
	 * The base class of data point selections actions. The selections are built from brushing or pending filters,
	 * usually as a form of multi-select (using the ctrl/command key or long press).
	 */
	class DataPointActionBase {
		constructor(options) {
			options = options || {};
			this.dashboard = options.dashboardAPI;
			this.logger = this.dashboard.getGlassCoreSvc('.Logger');
			this.content = options.content;
			this.globalFilters = this.dashboard.getFeature('GlobalFilters');
			this.eventGroups = this.dashboard.getFeature('EventGroups');
			this.transaction = this.dashboard.getFeature('Transaction');
		}

		_getLocalFilters() {
			if (!this.localFilters) {
				this.visualization = this.visualization || this.content.getFeature('Visualization');
				this.localFilters = this.visualization.getLocalFilters();
			}
			return this.localFilters;
		}

		_getSelector() {
			const type = this.dashboard.getAppConfig('pageContainerType');
			const page = ContentUtil.getPageContent(this.content, type);
			return {
				origin: 'visualization',
				sourceId: this._getVisualization().getDataSource().getId(),
				scope: page && page.getId(),
				eventGroupId: this.eventGroups.getGroupId(this.content.getId()),
				//use the 'strict match option' and event source to only select brushing entries
				//that originate from this visualization.
				eventSourceId: this.content.getId(),
				_strictMatch: true
			};
		}

		_getVisualization() {
			this.visualization = this.visualization || this.content.getFeature('Visualization');
			return this.visualization;
		}

		_groupSelections(selectionList) {
			let groupedSelections = {};
			if (!selectionList || !selectionList.length) {
				return;
			}

			let columnIdList = null;
			let tupleList = null;
			const categoryList = _.pluck(selectionList, 'categories');
			categoryList.forEach(tuple => {
				tupleList = [];
				columnIdList = [];
				tuple && tuple.forEach(value => {
					columnIdList.push(value.columnId);
					// TODO Add .u and .d internally until all internal implementation classes (pageContext, filters etc.) use .value and .label.
					value.u = value.value;
					value.d = value.label;
					if (value.parentId) {
						value.p = {
							u: value.parentId
						};
					}
					tupleList.push(value);
				});

				const groupKey = _.uniq(columnIdList).join();
				if (!groupedSelections[groupKey]) {
					groupedSelections[groupKey] = [];
				}
				groupedSelections[groupKey].push(tupleList);
			});
			return groupedSelections;
		}
	}

	return DataPointActionBase;

});
